function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M474.668 251H165.332c-8.832 0-16-7.168-16-16s7.168-16 16-16h309.336c8.832 0 16 7.168 16 16s-7.168 16-16 16zm0 0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M250.668 336.332c-4.098 0-8.191-1.555-11.309-4.691l-85.332-85.332c-6.25-6.254-6.25-16.387 0-22.637l85.332-85.332c6.25-6.25 16.383-6.25 22.637 0 6.25 6.25 6.25 16.383 0 22.633L187.97 235l74.027 74.027c6.25 6.25 6.25 16.383 0 22.633a16.02 16.02 0 01-11.328 4.672zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M234.668 469.668C105.281 469.668 0 364.387 0 235S105.281.332 234.668.332c97.086 0 182.805 58.41 218.41 148.824 3.242 8.211-.812 17.492-9.023 20.754-8.215 3.203-17.496-.789-20.758-9.043-30.742-78.082-104.79-128.535-188.629-128.535C122.922 32.332 32 123.258 32 235s90.922 202.668 202.668 202.668c83.84 0 157.887-50.453 188.629-128.512 3.242-8.258 12.523-12.246 20.758-9.047 8.21 3.243 12.265 12.543 9.023 20.758-35.605 90.39-121.324 148.801-218.41 148.801zm0 0"
});

function SvgSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -10 490.667 490",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2, _ref3);
}

export default SvgSignOut;